import { StringParseError } from '@amazon/vinyl-util'
import { graphql } from './graphql'

const unexpectedTokenRegex = /Unexpected token at (\d+)/

const graphQlWrapped = (...args: Parameters<typeof graphql>) => {
    try {
        return graphql(...args)
    } catch (error: unknown) {
        const message = error instanceof Error ? error.message : undefined
        const match = message ? unexpectedTokenRegex.exec(message) : null
        if (match) {
            const position = parseInt(match[1])
            throw new StringParseError(args[0], position, 'gql')
        }
        throw error
    }
}
Object.assign(graphQlWrapped, {
    ...graphql,
})

export const gql: typeof graphql = graphQlWrapped as typeof graphql
